module.exports = __webpack_public_path__ + "img/mat_215.cc192dfa.png";